const PREFIX = "notification";

export const UserJoinSuccess = `${PREFIX}:UserAddToGroupSuccess`;
export const UserLeaveSuccess = `${PREFIX}:UserRemoveFromGroupSuccess`;
export const UserJoinFail = `${PREFIX}:UserAddToGroupFail`;
export const UserLeaveFail = `${PREFIX}:UserRemoveFromGroupFail`;
